import { useState, useCallback, useEffect } from 'react';
import { fetchCarrierByCode } from '../services/api';

export const useCarrierActions = formData => {
  const [carrierData, setCarrierData] = useState(null);
  const [carrierEmails, setCarrierEmails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCarrierData = useCallback(async carrierCode => {
    if (!carrierCode) {
      setCarrierData(null);
      setCarrierEmails([]);
      return null;
    }

    setLoading(true);
    setError(null);

    try {
      const data = await fetchCarrierByCode(carrierCode);

      if (data) {
        setCarrierData(data);

        // Construire la liste des emails transporteur
        const emails = [];

        if (data.establishment_email && data.establishment_email !== '') {
          emails.push(data.establishment_email);
        }

        if (
          data.billing_email &&
          data.billing_email !== '' &&
          !emails.includes(data.billing_email)
        ) {
          emails.push(data.billing_email);
        }

        if (data.email_book && data.email_book !== '') {
          const emailBookEmails = data.email_book
            .split(',')
            .map(email => email.trim())
            .filter(email => email && !emails.includes(email));
          emails.push(...emailBookEmails);
        }

        // Filtrer les emails vides
        const filteredEmails = emails.filter(email => email !== '');
        setCarrierEmails(filteredEmails);

        return { data, emails: filteredEmails };
      }

      return null;
    } catch (err) {
      console.error('Erreur lors de la récupération des données transporteur:', err);
      setError(err.message);
      setCarrierEmails([]);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const resetCarrierData = useCallback(() => {
    setCarrierData(null);
    setCarrierEmails([]);
    setError(null);
  }, []);

  const getDefaultCarrierEmail = useCallback(() => {
    return carrierEmails.length > 0 ? carrierEmails[0] : '';
  }, [carrierEmails]);

  useEffect(() => {
    if (formData && formData.carrier) {
      fetchCarrierData(formData.carrier);
    } else {
      resetCarrierData();
    }
  }, [formData?.carrier, fetchCarrierData, resetCarrierData]);

  return {
    carrierData,
    carrierEmails,
    loading,
    error,
    fetchCarrierData,
    resetCarrierData,
    getDefaultCarrierEmail,
  };
};
